// extracted by mini-css-extract-plugin
export default {"root":"SellReasons-root","reasonCard":"SellReasons-reasonCard","reasonImage":"SellReasons-reasonImage"};